import React from 'react';
import './footer.scss';

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ ...rest }) => {
  return <footer className={'footer'} {...rest} />;
};
